import React, { useState, useEffect, useContext } from "react";
import { formatDateTime, isoToSqlDate } from "../../../helpers/helpers";
import ijws from "../../../services/ijws";
import AppContext from "../../../container/context";
import ActionTable from "../../../components/table/ActionTable";
import Form from "../../../components/form";
import modalidadeAssinatura from "../../../enums/modalidadeAssinatura";

import { CircularProgress } from "@mui/material";

const Lista = ({ history }) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [filtros, setFiltros] = useState({
    inicioVigencia: isoToSqlDate(new Date().toISOString()),
    fimVigencia: isoToSqlDate(new Date().toISOString()),
  });
  const [planos, setPlanos] = useState([]);

  useEffect(() => {
    listar();
  }, []);

  const listar = (filtrosEnviar = filtros) => {
    setCarregando(true);
    setFiltros(filtrosEnviar);

    ijws
      .get("admin/planos/listar", filtrosEnviar)
      .then((planos) => {
        planos.forEach((p) => {
          p.valor = (p.valorCentavos / 100).toFixed(2);
          p.inicioVigencia = formatDateTime(p.inicioVigencia, "D/M/Y");
          p.fimVigencia = formatDateTime(p.fimVigencia, "D/M/Y");
          p.principal = p.principal ? "Sim" : "";

          // if (p.modalidadeAssinatura === 1) p.modalidade = "Boleto bancário";
          // if (p.modalidadeAssinatura === 2) p.modalidade = "Cartão de crédito";
          // if (p.modalidadeAssinatura === 3) p.modalidade = "Pix";
        });

        setPlanos(planos);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível listar os planos");
        setCarregando(false);
      });
  };

  const camposFiltro = (filtros) => ({
    inicioVigencia: {
      label: "Início vigência (a partir de)",
      type: "date",
      value: filtros.inicioVigencia
        ? formatDateTime(filtros.inicioVigencia, "Y-M-D")
        : null,
      required: true,
      space: 6,
    },
    fimVigencia: {
      label: "Fim vigência (até)",
      type: "date",
      value: filtros.fimVigencia
        ? formatDateTime(filtros.fimVigencia, "Y-M-D")
        : null,
      required: true,
      space: 6,
    },
  });

  const fFiltros = {
    form: camposFiltro(filtros),
    submit: {
      label: "Filtrar",
      action: listar,
    },
  };

  const tRegistros = {
    title: "Plano",
    array: planos,
    columns: [
      { name: "nome", label: "Nome" },
      {
        name: "modalidadeAssinatura",
        label: "Modalidade de assinatura",
        domain: modalidadeAssinatura,
      },
      { name: "valor", label: "Valor R$" },
      { name: "qtdParcelas", label: "Qtd. Parcelas" },
      { name: "inicioVigencia", label: "Início vigência" },
      { name: "fimVigencia", label: "Fim vigência" },
      { name: "principal", label: "Principal" },
    ],
    key: "id",
    newItemAction: () => history.push("/app/planos-ij/0"),
    onLineClick: (id) => history.push(`/app/planos-ij/${id}`),
  };

  return (
    <div>
      <Form formData={fFiltros} />

      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <ActionTable structure={tRegistros} />
        </>
      )}
    </div>
  );
};

export default Lista;
